import axios from 'axios';

const selectors = {
  dropdownTrigger: '[data-trigger-blog-links]'
};

  
export default function init ({ el, context }) {

	const nodeSelectors = {
    dropdownTrigger: el.querySelector(selectors.dropdownTrigger)
  }


  nodeSelectors.dropdownTrigger.addEventListener('click', async (event) => {
  	event.preventDefault();
  	let thisTrigger = event.currentTarget
    thisTrigger.classList.toggle('active')
    let conentElement = thisTrigger.parentElement.nextElementSibling
    if(conentElement.getAttribute('aria-hidden') === 'true'){
      conentElement.setAttribute('aria-hidden', false)
    } else {
      conentElement.setAttribute('aria-hidden', true)
    }
  });

}